import React from 'react';

const PageHeading = ({title}) => (
    <div className="page-heading">
        <div className="wrapper">
            <h1 className="entry-title page-heading__title">{title}</h1>
        </div>
    </div>
);

export default PageHeading;



// WEBPACK FOOTER //
// ./src/components/PageHeading/index.js